import { selectMealSubtypes } from '.'

export const filteringOnlyByMealSubtypes = (filteredSubtypes: string[]) => {
  const isFilteringByAllSubtypes = filteredSubtypes.length === 0
  if (isFilteringByAllSubtypes) return false

  const allFiltersAreMealSubtype =
    selectMealSubtypes(filteredSubtypes).length === filteredSubtypes.length

  return allFiltersAreMealSubtype
}
